import type { RouteObject } from 'react-router-dom';

import App, { type AppProps } from './App';
import { getLocalisedRoutes } from './routes';
import { routeNameToPage } from './routes/routeNameToPage';
import { getEnvironment } from './utils/environment';

export const createRoutes = (props: AppProps): RouteObject[] => {
  const availableRoutes = getLocalisedRoutes(props.site).filter(
    (route) =>
      !route.onlyAvailableInEnv ||
      route.onlyAvailableInEnv.includes(getEnvironment()),
  );

  const routes: RouteObject[] = availableRoutes
    .map(({ name, route }) => {
      const { Container, Page } = routeNameToPage[name];

      const element = Container ? (
        <Container>
          <Page />
        </Container>
      ) : (
        <Page />
      );
      return {
        id: route,
        path: route,
        element,
      };
    })
    .filter(Boolean) as RouteObject[];

  return [
    {
      element: <App {...props} />,
      children: routes,
      id: 'root',
    },
  ] as RouteObject[];
};
